import type { InsuranceScenarioResultColumn } from '@/general/src/insuranceScenario/webapp.js'

export const personalOsagoInsuranceScenarioResultColumns: InsuranceScenarioResultColumn[] = [
  {
    heading: 'Стоимость',
    width: 120,
    key: 'price',
    body: (sd) => sd.result.price || '—',
  },
  {
    heading: 'Прочее',
    width: 300,
    key: 'otherData',
    body: (sd) => {
      const data = sd.result.otherData

      if (!data || Object.keys(data).length === 0) {
        return '—'
      }
      return Object.entries(data).map(([key, value]) => {
        return (
          <div key={key}>
            {key}: {value as string}
          </div>
        )
      })
    },
  },
  {
    heading: 'Идентификатор в страховой',
    width: 170,
    key: 'externalId',
    body: (sd) => sd.result.externalId || '—',
  },
]
